import { render, staticRenderFns } from "./BrigadeActiveRequestsTab.vue?vue&type=template&id=66bb6eee&scoped=true&"
import script from "./BrigadeActiveRequestsTab.vue?vue&type=script&lang=js&"
export * from "./BrigadeActiveRequestsTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66bb6eee",
  null
  
)

export default component.exports
import {QItem,QTable,QTr,QTh,QTd,QBtn,QTooltip,QInnerLoading,QSpinnerGears} from 'quasar'
component.options.components = Object.assign({QItem,QTable,QTr,QTh,QTd,QBtn,QTooltip,QInnerLoading,QSpinnerGears}, component.options.components || {})
